import axios from "axios";
import config from "../config";

// const https = require('https');
//
// const agent = new https.Agent({
//     rejectUnauthorized: false,
// });

const instance = axios.create({
  baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("token");
  config.headers.Authorization = token ? token : "";
  config.headers['Content-Type'] = "application/json";
  return config;
});



//Subscription
export const createSessionForCheckoutPayment = async(info)=> await instance.post('subscription/checkout-training-session',info);
export const createUniqueSessionForCheckout = async(info)=> await instance.post('subscription/session',info)
export const CheckCandidateSubscription = async(email)=> await instance.get(`subscription/check/${email}`);
export const getAllActiveSubscriptionProducts = async()=> await instance.get('SubscriptionStripeProducts/active');
export const CreateSessionForPortailBillingStripe = async(custId)=> await instance.get(`subscription/portalBillingByCustomer/${custId}`);
export const FetchSubscriptionProduct = async(productId)=> await instance.get(`subscription/price/${productId}`);

//training for Candidates
export const fetchOneTraining = async(id)=> await instance.get(`TrainingCandidates/${id}`)
export const fetchActiveTrainings = async(type)=> await instance.get(`TrainingCandidates/active?type=${type}`);

export const registerForCorporateAccount = async (
  firstName,
  lastName,
  email,
  company,
  password,
  country,
) =>
  await instance.post("users/registerForCorporateAccount", {
    firstName,
    lastName,
    email,
    company,
    password,
    country,
  });

  export const registerForPersonalAccount = async (
    firstName,
    lastName,
    email,
    password,
    country,
    acceptNewsletterReception
  ) => await instance.post("users/register", 
        {
          firstName,
          lastName,
          email,
          password,
          country,
          acceptNewsletterReception
        }
      );
  
  



export const confirmRegister = async (id) =>
  await instance.post(`users/confirm/${id}`);

export const forgotPassword = async (email) =>
  await instance.post("users/forgotpassword", { email });

 export const checkPassReset = async (token) =>
  await instance.post(`users/check/resetpass/${token}`);



export const confirmReset = async (id, password) =>
  await instance.post(`users/resetpass/${id}`, { password });

export const login = async (email, password) =>
  await instance.post("users/login", { email, password });

export const logout = async (token) =>
  await instance.post("users/logout", { token });

export const edit = async (formData) =>{ console.log("sikimimi",formData)
  await instance.post("/users/edit",  formData );}


  export const getCompanyUsers = async (companyID) => await instance.get(`users/getcompanyusers/${companyID}`);
  export const getUserByID = async (userID) => await instance.get(`users/getUserByID/${userID}`);
  export const editUserCompany = async (
    userID,
    firstname,
    lastName,
    email,
    company,
    password,
    role,
  ) =>
    await instance.post("employer/editusercompany", {
      userID,
      firstname,
      lastName,
      email,
      password,
      role,
    });

    export const editCompanyUserByTheAdmin = async (
      firstName,
      lastName,
      email,
      accessLevel,
      password,
    ) =>
      await instance.post("users/editCompanyUserByTheAdmin", {
        firstName,
        lastName,
        email,
        accessLevel,
        password,
      });
    export const addNewCompanyUser = async (
      firstName,
      lastName,
      email,
      company,
      password,
      role,
      companyID,
      accessLevel,
    ) =>
      await instance.post("users/addNewCompanyUser/", {
        firstName,
        lastName,
        email,
        company,
        password,
        role,
        companyID,
        accessLevel,
      });

      export const editPersonalUser = async (
        firstName,
        lastName,
        email,
        country,
      ) =>
        await instance.post("users/editPersonalUser/", {
          firstName,
          lastName,
          email,
          country,
        });
  
